var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-page',[_c('navbar',{attrs:{"text":_vm.$t('WorkOrder_title')}}),_vm._v(" "),_c('DxWorkOrders',{attrs:{"exclude-activities":_vm.excludeActivities,"key-name":'workOrders'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }